import React from 'react'

const ErrorPage = () => {
  return (
    <>
      <p>Er is een fout opgetreden</p>
      <div>
        <a href="/login" target="_self" onClick={() => window.location.reload()}>
          Opnieuw proberen
        </a>
      </div>
    </>
  )
}

export default ErrorPage
